/**
 *
 * @param url
 */
const openInNewTab = url => {
  const win = window.open(url, '_blank');
  win.focus();
};

export default openInNewTab;
